import { useEffect } from 'react';

// useDirtyBuffer registers a global "dirty buffer" flag that the site
// switcher (and other navigation interceptors) can read synchronously.
// Pages with unsaved edits flip it true; saving or unmounting flips it
// back to false. The state lives at module scope rather than in React
// state so SiteContext.setSite can read it inline without subscribing.

let dirty = false;
let label = '';
const subscribers = new Set<() => void>();

export function isDirty(): boolean {
  return dirty;
}

export function dirtyLabel(): string {
  return label;
}

export function setDirty(next: boolean, lbl = ''): void {
  const nextLabel = next ? lbl : '';
  if (dirty === next && label === nextLabel) return;
  dirty = next;
  label = nextLabel;
  subscribers.forEach((cb) => cb());
}

export function subscribeDirty(cb: () => void): () => void {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
}

export function useDirtyBuffer(active: boolean, lbl = ''): void {
  useEffect(() => {
    setDirty(active, lbl);
    return () => {
      setDirty(false);
    };
  }, [active, lbl]);
}
